// Settings Service - API calls for user settings
import api from './api';

const settingsService = {
  // Get all settings
  async getSettings() {
    const response = await api.get('/settings');
    return response;
  },

  // Update settings
  async updateSettings(settings) {
    const response = await api.put('/settings', settings);
    return response;
  }
};

export default settingsService;
